<template>
  <Autocomplete
    autocomplete_class="pt-0 mt-0 h7-text width-100 select-organizations"
    :class="['select-organization', {'multiple': multiple, 'rounded': !transparent}]"
    color="var(--text-color)"
    data-qa="toolbar-organization"
    :disabled="disabled"
    hide_detail
    item_slot
    item_text="titleWithOkpo"
    :item_value="keyField"
    :items.sync="available_organizations"
    :menu-props="{contentClass:'select-organizations-list'}"
    :model.sync="value"
    :multiple="multiple"
    not_clearable
    :placeholder="$t(placeholder)"
    :readonly="readonly"
    :return_object="return_object"
    :rounded="!transparent"
    :selection_slot="multiple"
    @blur="val => $emit('blur', val)"
    @change_text="val => $emit('change', val)"
    @click.stop>
    <template #selection="{ index }">
      <span
        v-if="!index"
        class="h7-text mr-2"
        style="white-space: nowrap;"
        :title="tooltip">
        {{ text }}
      </span>
    </template>
    <template #item="{ item, attrs }">
      <div
        class="my-2 d-flex align-center"
        style="max-width: 400px">
        <v-checkbox
          v-if="multiple"
          v-model="attrs.inputValue"
          class="my-auto"
          dense
          hide-details
          @click.stop="clickCheckBox(item, attrs.inputValue)"/>
        {{ item.title }}
        <template v-if="!item.existsOpkoInTitle && item.oKPO">
          {{ ` (${item.oKPO})` }}
        </template>
      </div>
    </template>
  </Autocomplete>
</template>
<script>
import Autocomplete from 'components/common/inputs/Autocomplete.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'orgsList',
  methods: {
    clickCheckBox(item, checked) {
      const value = item[this.keyField]
      if (checked && !this.value.find(i => i === value)) {
        const result = this.$_.cloneDeep(this.value)
        result.push(value)
        this.value = result
      } else if (!checked && this.value.find(i => i === value)) {
        const result = this.$_.cloneDeep(this.value)
        const index =  result.indexOf(value)
        result.splice(index, 1)
        this.value = result
      }
    }
  },
  props: {
    model: [Array, Number, Object],
    disabled: Boolean,
    readonly: Boolean,
    /**
     * Без рамок, фона и меньшей высоты
     */
    transparent: {
      type: Boolean,
      default: false
    },
    /**
     * множественный выбор
     */
    multiple: {
      type: Boolean,
      default: true
    },
    return_object: {
      type: Boolean,
      default: true
    },
    organizations: {
      type: Array
    },
    keyField: {
      type: String,
      default: 'organizationItId'
    },
    placeholder: {
      type: String,
      default: 'Common.CurrentObject'
    }
  },
  computed: {
    ...mapGetters({
      allOrganizations: 'getAvailableOrganizations',
    }),
    value: {
      get() {
        return this.model || (this.multiple ? [] : {})
      },
      set(value) {
        this.$emit('update:model', value)
      }
    },
    available_organizations() {
      let result = this.organizations
        ? this.organizations
        : this.allOrganizations || []

      result = result.map(i => {
        return {
          ...i,
          titleWithOkpo: i.oKPO ? (i.title.includes(i.oKPO) ? i.title : `${i.title} (${i.oKPO})`) : i.title,
          existsOpkoInTitle: i.title.includes(i.oKPO)
        }
      })

      return result
    },
    tooltip() {
      if (!this.multiple) {
        return ''
      }
      return this.value?.length
        ? this.value.map(el =>
          this.return_object
            ? el?.title
            : this.$_.find(this.availableOrganizations, it => it[this.keyField] == el)?.title).join(', \n')
        : ''
    },
    text() {
      if (!this.value?.length) {
        return this.$t('Purchasing.All')
      } else {
        return this.value?.length + ' ' + this.$tc('Common.Organizations', this.value?.length)
      }
    },
  },
  components: {
    Autocomplete
  }
}
</script>
<style lang="scss">
.select-organizations {
  div.v-input__control {
    &, .v-input__slot {
      padding: 0 !important;
    }
    .v-select__selections {
      flex-wrap: nowrap;
    }
  }
  &.rounded {

    div.v-input__control {
      .v-input__slot {
        padding: 0 10px !important;
      }
    }
  }
  .s-select__tags {
    flex-wrap: nowrap;
  }
}
.select-organizations-list {
  max-width: 400px;
  box-shadow: 1px 1px 4px 0px var(--white-color) !important;
  .v-input--checkbox {
    padding: 0 !important;
    div.v-input__control input {
      margin-top: 0;
    }
  }
  .organisation-title {
    line-height: 20px;
    padding: 10px 0;
  }
  ul {
    padding-left: 0;
  }
}
</style>
